import {INIT_APP} from '~/common/fabric/constants';
import {CREATE_EDIT_POLL} from '~/common/fabric/reducers/widgets';
import {POLL_VOTE_UPDATED, SUBMIT_RSVP, UPDATE_INVITATION_SUMMARY} from './constants';

const initialState = {
  question: '',
  options: [],
  Id: 0,
  optionSelectedByUser: null,
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INIT_APP:
      return {
        ...state,
        ...window?.event_widgets?.polls?.[0],
      };
    case CREATE_EDIT_POLL:
      return {
        ...state,
        ...action?.payload?.polls?.[0],
      };
    case POLL_VOTE_UPDATED: {
      return action.results;
    }
    case SUBMIT_RSVP:
      return {
        ...state,
        hasSubmittedRSVP: true,
      };
    case UPDATE_INVITATION_SUMMARY: {
      const {poll} = action.results;
      if (!poll || !poll.question || !poll.id) return {initialState};
      return {
        ...poll,
      };
    }
    default:
      return state;
  }
}

export function initPoll() {
  const pollData = window?.event_widgets?.polls?.[0];
  return {
    type: INIT_APP,
    ...pollData,
  };
}

export const selectPollOptions = (state) => state.poll.options ?? [];
export const selectPollQuestion = (state) => state.poll.question;
export const selectTotalPollResponseCount = (state) => state.poll.total_response_count;
export const selectPollId = (state) => state.poll.id;
export const selectUserVoted = (state) => state.poll.voted;
export const selectOptionSelectedByUser = (state) => state.poll.option_selected_by_user;
